import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer
} from 'recharts';

const pastelColors = [
  '#7FB3D5', '#76D7C4', '#F8C471', '#F1948A', '#BB8FCE',
  '#F7DC6F', '#73C6B6', '#C39BD3', '#82E0AA', '#F5B7B1',
];

export default function FeatureUsageChart({ data }) {
  // now we treat "period" (timestamp) as x-axis; filter out 'period' key
  const featureKeys = Object.keys(data[0] || {})
    .filter(key => key !== 'period');

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{ top: 10, right: 10, left: 0, bottom: 60 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#2f2f2f" />

        {/* X-Axis: period (timestamp) */}
        <XAxis
          dataKey="period"
          type="category"
          interval={0}
          height={60}
          tick={{
            fill: '#d1d5db',
            fontSize: 12,
            angle: -45,
            textAnchor: 'end'
          }}
          axisLine={{ stroke: '#4b5563' }}
        />

        {/* Y-Axis: usage counts */}
        <YAxis
          type="number"
          tick={{ fill: '#d1d5db', fontSize: 12 }}
          axisLine={{ stroke: '#4b5563' }}
        />

        <Tooltip
          cursor={{ fill: 'rgba(255, 255, 255, 0.05)' }}
          contentStyle={{
            backgroundColor: '#1f2937',
            borderColor: '#4b5563',
            borderRadius: '6px',
            padding: '6px 8px',
            fontSize: '0.75rem',
            color: '#f9fafb',
          }}
          itemStyle={{ fontSize: '0.75rem', padding: 0, color: '#e5e7eb' }}
          labelStyle={{ color: '#93c5fd', fontWeight: 500 }}
        />

        <Legend wrapperStyle={{ paddingTop: 10, color: '#e5e7eb' }} />

        {featureKeys.map((key, i) => (
          <Bar
            key={key}
            dataKey={key}
            stackId="a"
            fill={pastelColors[i % pastelColors.length]}
            radius={[4, 4, 4, 4]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}